import styled from 'styled-components';

export const Banner = styled.div<any>`
  background: var(--cvna-color-red-1);
  padding: 24px 18px;
  color: var(--cvna-color-blue-6);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  gap: 8px;

  > div: first-child {
    display: flex;
    align-items: flex-start;
    padding-top: 4px;
  }
`;